var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-cell-label",class:this.cellClassName,style:(_vm.widthStyle)},[_c('span',{ref:"label",staticStyle:{"display":"block"},attrs:{"title":_vm.label}},[_vm._v(" "+_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }